export default {
  OPEN_NON_UPDATED_DOSSIERS_MODAL: 'OPEN_NON_UPDATED_DOSSIERS_MODAL',
  CLOSE_NON_UPDATED_DOSSIERS_MODAL: 'CLOSE_NON_UPDATED_DOSSIERS_MODAL',
  FETCH_NON_UPDATED_DOSSIERS: 'FETCH_NON_UPDATED_DOSSIERS',
  FETCH_NON_UPDATED_DOSSIERS_SUCCESS: 'FETCH_NON_UPDATED_DOSSIERS_SUCCESS',
  DELAY_NON_UPDATED_DOSSIER: 'DELAY_NON_UPDATED_DOSSIER'
}
